import { Box, Button, Container } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect, useState, useRef } from "react";

import AreYouSureModal from "@/components/IEBPage/AreYouSureModal";
import ChooseIEBFileModal from "@/components/IEBPage/ChooseIEBFileModal";
import DonutChart from "@/components/IEBPage/DonutChart";
import IEBFilter from "@/components/IEBPage/IEBFilter";
import IEBTable from "@/components/IEBPage/IEBTable";
import { useIEBPage } from "@/components/IEBPage/useIEBPage";
import Notifications from "@/components/Notifications/Notifications";

function IEBPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [areYouSureOpen, setAreYouSureOpen] = useState(false);
  const [modalRowData, setModalRowData] = useState({
    local: "",
    files: [],
    IEBDate: null,
  });
  const [pendingIEBDate, setPendingIEBDate] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [datepickerKey, setDatepickerKey] = useState(0);
  const filterRef = useRef(null);

  const {
    IEBData,
    dropdownOptions,
    currentIEBDate,
    notification,
    setNotification,
    allRows,
    setFile,
    handleExport,
    updateIEBDate,
  } = useIEBPage();

  useEffect(() => {
    setFilteredRows(allRows);
  }, [allRows]);

  const handleOpenModal = (row) => {
    setModalRowData({
      local: row.name,
      files: IEBData[row.name]["available"],
      IEBDate: row.IEBTimestamp,
    });
    setModalOpen(true);
  };

  const handleModalClose = (affiliate, chosenFile) => {
    setModalOpen(false);
    // clear filters when the modal is closed
    if (filterRef.current) {
      filterRef.current.reset();
    }
    if (affiliate) {
      setFile(affiliate, chosenFile);
    }
  };

  const handleIEBDateChange = (newIEBDate) => {
    setPendingIEBDate(newIEBDate);
    setAreYouSureOpen(true);
  };

  const handleCloseAreYouSureModal = async (confirmed) => {
    setAreYouSureOpen(false);
    if (confirmed && pendingIEBDate) {
      await updateIEBDate(pendingIEBDate);
    } else {
      // force DatePicker to re-render with old value
      setDatepickerKey((prev) => prev + 1);
    }
    setPendingIEBDate(null);
  };

  const handleFilteredRows = (rows) => {
    setFilteredRows(rows);
  };

  return (
    <>
      <Container sx={{ marginTop: "30px" }}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "1000px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "16px",
            }}
          >
            <DonutChart data={IEBData} />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ marginRight: "10px" }}>
              <Box sx={{ marginBottom: "10px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: "100%", backgroundColor: "white" }}
                    key={datepickerKey}
                    label="IEB Date"
                    value={currentIEBDate}
                    onChange={handleIEBDateChange}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ marginBottom: "10px" }}>
                <IEBFilter
                  ref={filterRef}
                  dropdownOptions={dropdownOptions}
                  rows={allRows}
                  handleFilteredRows={handleFilteredRows}
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <Button
                  sx={{ width: "100%", marginBottom: "10px" }}
                  className="siteBlue"
                  onClick={handleExport}
                >
                  Export
                </Button>
              </Box>
            </Box>
            <Box sx={{ width: "100%" }}>
              <IEBTable
                filteredRows={filteredRows}
                handleOpenModal={handleOpenModal}
              />
            </Box>
          </Box>
        </Box>
        <ChooseIEBFileModal
          keepMounted
          open={modalOpen}
          onClose={handleModalClose}
          rowData={modalRowData}
          key={modalRowData.local}
        />
        <AreYouSureModal
          open={areYouSureOpen}
          onClose={handleCloseAreYouSureModal}
          newIEBDate={pendingIEBDate}
        />
      </Container>

      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}

export default IEBPage;
